import CategoryDetailListStyle from '../components/CategoryDetailList'

export default {
  ...CategoryDetailListStyle,
  'current-quantity-label': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    background: '#C54545',
    fontSize: 16,
    minWidth: 28,
    height: 28,
    borderRadius: 18,
    marginRight: 10,
    padding: 4,
    boxSizing: 'border-box',
  },
  'customizedCode-label-style': {
    color: '#C54545',
    minHeight: '25px',
    wordWrap: 'break-word',
  },
  'sold-out-label-style': {
    color: '#C54545',
    minHeight: '25px',
    marginLeft: '10px',
    display: 'inline-block',
    wordWrap: 'break-word',
  },
  'minus-button': {
    width: 'calc(55% - 10px)',
    border: '1px solid #4A8CA1',
    height: '40px',
    marginLeft: '10px',
    textAlign: 'center',
    fontSize: '18px',
    lineHeight: '40px',
    verticalAlign: 'middle',
    borderRadius: '20px',
    color: '#4A8CA1',
  },
  'waiter-stepper-item-container': {
    display: 'flex',
    flexDirection: 'column',
    lineHeight: 1.5,
    margin: '0px',
    height: 'calc(100% - 2px)',
    width: '100%',
    minHeight: '120px',
    border: 'solid 1px #000',
    transition: 'background-color 150ms ease',
  },
  'highlight-backgound': {
    backgroundColor: '#DBC060',
  },
  'waiter-stepper-item-top': {
    marginTop: 10,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  'waiter-stepper-item-bottom': {
    alignContent: 'flex-end',
    margin: '10px 0px',
    alignSelf: 'flex-end',
    width: '100%',
    zIndex: '2',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  'price-labels-container': {
    height: '100%',
    width: 'calc(40% - 10px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,
    lineHeight: 1,
  },
  'title-container': {
    marginLeft: '10px',
    width: 'calc(65% - 10px)',
    minHeight: 60,
    alignSelf: 'stretch',
    wordWrap: 'break-word',
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/WaiterStepperItem.js